import { styled } from '@mui/material/styles';
import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress';

const Progressbar = styled(LinearProgress, { shouldForwardProp: prop => prop !== 'error' })(({ theme, error }) => ({
    height: 10, borderRadius: "10px", width: '100%',
    [`&.${linearProgressClasses.colorPrimary}`]: { backgroundColor: theme.palette.grey[theme.palette.type === 'light' ? 200 : 700], },
    [`& .${linearProgressClasses.bar}`]: { borderRadius: "10px", backgroundColor: error ? 'red' : '#00fd01', },
}));

export default Progressbar;